interface UnknownMeterReadingSnapshotState {
    meterNumber: string;
    readingValue: string;
    images: string[];
    readingDate: Date;
    comment?: string;
}

export const buildUnknownMeterReadingSnapshot = ({
    accountId,
    unknownReading,
}: {
    accountId: string;
    unknownReading: UnknownMeterReadingSnapshotState;
}) => ({
    accountId,
    meterNumber: unknownReading.meterNumber,
    readingValue: unknownReading.readingValue,
    images: (unknownReading.images ?? []).filter((image) => image.length > 0),
    readingDate: unknownReading.readingDate.toISOString(),
    comment: unknownReading.comment ?? '',
});

export type UnknownMeterReadingSnapshot = ReturnType<typeof buildUnknownMeterReadingSnapshot>;

export const isUnknownMeterReadingDirty = (initialSnapshot: UnknownMeterReadingSnapshot, currentSnapshot: UnknownMeterReadingSnapshot) =>
    JSON.stringify(initialSnapshot) !== JSON.stringify(currentSnapshot);

export const resolveUnknownMeterReadingBaselineAfterAccountAutoSelect = ({
    initialSnapshot,
    selectedAccountId,
    unknownReading,
}: {
    initialSnapshot: UnknownMeterReadingSnapshot;
    selectedAccountId: string;
    unknownReading: UnknownMeterReadingSnapshotState;
}) => {
    const snapshotBeforeAutoSelect = buildUnknownMeterReadingSnapshot({
        accountId: '',
        unknownReading,
    });

    if (isUnknownMeterReadingDirty(initialSnapshot, snapshotBeforeAutoSelect)) {
        return initialSnapshot;
    }

    return buildUnknownMeterReadingSnapshot({
        accountId: selectedAccountId,
        unknownReading,
    });
};
